/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';
import { AbstractRestService, identity, none, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';

import { LetterDto, LetterFinalVersionDto, QuotationPrintRequestDto, QuotationPrintResponseDto } from './letter.dto';
import {
  LetterFinalVersionMapper,
  LetterMapper,
  QuotationPrintRequestMapper,
  QuotationPrintResponseMapper,
} from './letter.mapper';

@Injectable()
export class LetterRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  prepareFirstContactLetter(salesFolderId: ID): Observable<LetterDto> {
    return this.httpGet(`${this.bp}/letters/prepare-first-contact-letter/${salesFolderId}`, LetterMapper);
  }

  buildFinalVersion(letter: LetterFinalVersionDto): Observable<LetterDto> {
    return this.httpPut(`${this.bp}/letters/build-final-version`, letter, LetterFinalVersionMapper, LetterMapper);
  }

  buildAuthorityToProceedLetter(salesFolderId: ID, quotationId?: ID): Observable<LetterDto> {
    return this.httpPost(
      `${this.bp}/letters/authority-to-proceed`,
      { quotationId, salesFolderId },
      identity(),
      LetterMapper);
  }

  printQuote(request: QuotationPrintRequestDto): Observable<QuotationPrintResponseDto> {
    return this.httpPost(
      `${this.bp}/letters/print-quote`,
      request,
      QuotationPrintRequestMapper,
      QuotationPrintResponseMapper);
  }

  remove(letter: LetterDto): Observable<void> {
    return this.httpDelete(`${this.bp}/letters`, letter, LetterMapper, none());
  }
}
